import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';
import AOS from 'aos';
import 'aos/dist/aos.css';
import * as moment from "moment";

declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-home-new',
  templateUrl: './home-new.component.html',
  styleUrls: ['./home-new.component.scss']
})
@Pipe({
	name: 'orderBy'
})
export class HomeNewComponent implements OnInit {
	transform = orderBy;

	newsList: any = "";
	homenewsList: any = "";
	hometcardList: any = "";
	homeupcomingList: any = "";
	homepastList: any = "";
	matchesnewList: any = "";
	seasontypeid: any = 7;
	matchesallrequest: any = {
		season_type_id: this.seasontypeid
	};
	homematchrequest: any = {
		series_type_id: 19
	};
	upcomingmatchesList: any = "";
	pastmatchesList: any = "";
	livematchesList: any = "";
	livematcheList: any = "";
	livematcheListWomen: any = "";
	livematchesListWomen: any = "";
	playerManList: any = "";
	playerWomanList: any = "";
	playerAcademyList: any = "";
	playerCoachingList: any = "";
	evnetList: any = "";
	evnetsecList: any = "";
	videoList: any = "";
	homevideoList: any = "";
	sponsorsList: any = "";
	seasonList: any = "";
	playerWomenList: any = "";
	bannerList: any = "";
	adbannerList: any = "";
	bannerbottomList: any = "";
	cricketsList: any = "";
	settingList: any = "";
	matchesList: any = "";
	membershipList: any = "";
	main_tabid = 15;
	second_tabid = 7;
	livestatus: any = "Live";
	status: any = "Upcoming";
	paststatus: any = "Past";
	player: any = "Men";
	timerconfig: any = {};
	matchesrequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.status
	};
	upcomingmatchrequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.status
	}
	pastmatchrequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.paststatus
	}
	liverequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.livestatus
	};
	liverequestwomen: any = {
		series_type_id: this.second_tabid,
		matche_status: this.livestatus
	};

	//playerrequest: any = {};
	bannerrequest: any = {};
	eventrequest: any = {};
	newsrequest: any = {
		news_catagory_id: "",
	};
	tcardrequest: any = {
		page: 1,
		pagesize: 4
	};
	videorequest: any = {
		video_catagory_id: 1
	};
	playerrequest = {
		team_type: this.player
	};
	constructor(private allpagesService: AllPageService
	) { }
	slidehomeConfig = {
		dots: true,
		infinite: true,
		arrows: false,
		slidesToShow: 1,
		autoplay: true,
		speed: 500,
		pauseOnHover: false, // Disable pausing on hover
        pauseOnFocus: false, // Disable pausing on focus
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	slidevideoConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					centerMode: true,
		            centerPadding: '10%',
				},
			},
		],
	};
	
	slideplayerConfig = {
		dots:false,
		infinite: true,
		speed: 600,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '27%',
		autoplay:false,
		autoplaySpeed: 2000,
		arrows:true,
		responsive: [
		{
			breakpoint: 1500,
			settings: {
				centerPadding: '24%',
			}
		},
		{
			breakpoint: 1366,
			settings: {
				centerPadding: '20%',
			}
		},
		{
			breakpoint: 1279,
			settings: {
				centerPadding: '13%',
			}
		},
		{
			breakpoint: 1023,
			settings: {
				centerPadding: '4%',
			}
		},
		{
			breakpoint: 767,
			settings: {
				centerPadding: '1%',
			}
		}
		],
	};
	
	
	slideadvertiseConfig = {
		dots: false,
		infinite: true,
		arrows:false,
		slidesToShow: 3,
		autoplay: true,
		speed: 500,
		autoplaySpeed: 4000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					centerMode: true,
		            centerPadding: '10%',
					infinite: true,
				},
			},
		],
	};
	slideimagehoverConfig = {
		dots: false,
		infinite: false,
		arrows:false,
		slidesToShow: 4,
		autoplay: true,
		speed: 500,
		autoplaySpeed: 6000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					centerMode: true,
		            centerPadding: '10%',
				},
			},
		],
	};
	
	ngOnInit() {

		
		jQuery(".popup-match-icon ul li.bat-boll a").click(function () {
			jQuery(".popup-match").addClass("open");
		});
		jQuery(".popup-match-icon ul li.close-popup a").click(function () {
			jQuery(".popup-match").removeClass("open");
		});
		jQuery(".player-name").on('change', function() {
			var playertype = $(this).val();
			jQuery(".player-home-inner").removeClass('active');
			jQuery('#'+ playertype).addClass('active');
			
		});
		jQuery(".social-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".social-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".social-name-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");;
			}
			return false;
		});
		this.loadhomescreennews();
		this.loadhomescreentcards();
		// this.loadhomescreenmatch();
		this.loadvideo();
		this.loadplayerMan();
		this.loadBanner();
		this.loadAdBanner();
		this.loadmatcheslive();
		//this.loadBannerbottom();
		this.loadplayerCoaching();
		this.loadplayerAcademy();
		this.loadplayerWomen();

		this.allpagesService.getAppsetting().then((data) => {
		this.settingList = data;
		// console.log(this.settingList); 
		});

		
			let request = Object.assign({}, this.homematchrequest);
			this.allpagesService.getHomeScreenMatchesList(request).then((data: any) => {
				this.homeupcomingList = data.data.upcoming;
				this.homepastList = data.data.past;
				console.log(this.homepastList);
				setTimeout(() => {
					this.predictCounter(data.data.upcoming.date_time);
				},1000);
			});
		
	}

	loadBanner() {
		this.bannerrequest = {
			title: 'Newhome'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data;
			//console.log(this.bannerList);
		});
	}

	loadAdBanner() {
		this.bannerrequest = {
			title: 'Home Ad New'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.adbannerList = data;
			//console.log(this.bannerList);
		});
	}

	loadBannerbottom() {
		this.bannerrequest = {
			title: 'Home Bottom'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerbottomList = data.data[0];
			//console.log(this.bannerList);
		});
	}

	loadplayerCoaching() {
		this.playerrequest.team_type = 'Coaching_Staff';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerCoachingList = data;
			//console.log(this.playerManList);
		});
	}

	loadplayerMan() {
		this.playerrequest.team_type = 'Men';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerManList = data;
			//console.log(this.playerManList);
		});
	}

	loadplayerAcademy() {
		this.playerrequest.team_type = 'Academy';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerAcademyList = data;
			//console.log(this.playerManList);
		});
	}

	loadplayerWomen() {
		this.playerrequest.team_type = 'Women';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerWomenList = data;
			console.log(this.playerWomenList);
		});
	}

	loadhomescreennews() {
		//let request = Object.assign({}, this.newsrequest);
		this.allpagesService.getHomescreenNewsletter().then((data: any) => {
			this.homenewsList = data;
			//console.log(data);
		});
	}

	loadhomescreentcards() {
		let request = Object.assign({}, this.tcardrequest);
		this.allpagesService.getHomeScreenTcard(request).then((data: any) => {
			this.hometcardList = data;
			//console.log(this.hometcardList);
		});
	}

	

	predictCounter(timevar: any){
    
		var enddate = new Date(timevar);
		var startdate = new Date();
		var seconds = (enddate.getTime() - startdate.getTime()) / 1000;
		var days_diff = (enddate.getTime() - startdate.getTime()) / (1000 * 3600 * 24);
		var newnum = days_diff.toFixed(0);
		this.timerconfig = { leftTime: seconds, format: '<ul><li>'+newnum+'</li><li>h</li><li>m</li><li>s</li></ul>' };
	}

	loadvideo() {
		let request = Object.assign({}, this.videorequest);
		this.allpagesService.getVideoListing(request).then((data: any) => {
			this.videoList = data;
			//console.log(this.videoList);
			setTimeout(() => {
				
				jQuery('.popup-youtube').magnificPopup({
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,

					fixedContentPos: false
				});
			}, 1000);
		});
	}

	loadmatcheslive() {
		let request = Object.assign({}, this.liverequest);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.livematcheList = data;
			this.livematchesList = data.data[0];

			console.warn(this.livematchesList);
		});
	}

}

